import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { setOrgDashboardAction } from "store/org";
import { showAlertAction } from "../store/alert";
import { setUserDashboard } from "../store/users";
import {
  getAllAreaInZoneAction,
  getAllBranchInAreaAction,
  getAllCoInBranchAction,
  getAllStateAction,
  getAllZonesInStateAction,
} from "../store/lists";
import { positionToOrgMapping, getOrgDashboardIdField } from "utils";
import { positionToOrgMapping2 } from "utils";
import { getOrgTableData } from "store/org";
import moment from "moment";
import { approveRemitance } from "store/org";
import { getTotal } from "utils";

const useDashboard = ({ id }) => {
  const {
    users: {
      user,
      userDashboardData,
      metaData: userMetaData,
      loadingDashboard,
    },
    org: { orgDashboardData, loadingOrgDashboard, metaData: orgMetaData },
  } = useSelector((state) => ({
    users: state.users,
    org: state.org,
  }));
  const { pathname } = useLocation();
  const { type, id: orgId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const permissionLevel = user.permissionLevel;
  const [viewListData, setViewListData] = useState();
  const [isOrgDashboard, setIsOrgDashboard] = useState(
    pathname.includes("org")
  );
  const userOrgField = positionToOrgMapping[user.position];
  const useUserDashboard = !isOrgDashboard && user.position === "DR";
  const [tableData, setTableData] = useState([]);
  const [loadingTableData, setLoadingTableData] = useState(false);
  const [tableMeta, _] = useState({
    startDate: moment().subtract(4, "days"),
    endDate: moment(),
  });
  const cardData = useUserDashboard
    ? userDashboardData?.cardsData
    : orgDashboardData?.cardsData;

  useEffect(() => {
    setIsOrgDashboard(pathname.includes("org"));
  }, [pathname]);

  const historyPushWithParam = (path, name) => {
    if (isOrgDashboard) {
      history.push(
        `${pathname}/dashboard-list/${path}?org=${
          type || userOrgField
        }&name=${name}`
      );
      return;
    }

    history.push(
      `/dashboard-list/${path}?org=${type || userOrgField}&name=${name}`
    );
  };

  const getUserDashboardViewList = (position, type) => {
    if ((position === "BM" && !isOrgDashboard) || type?.includes("branch")) {
      return {
        name: "View All Credit Officers",
        id: "co",
        onClick: async (id, name) => {
          await dispatch(
            getAllCoInBranchAction({ branchId: id, permissionLevel })
          );
          historyPushWithParam("cos", name);
        },
      };
    }
    if ((position === "AM" && !isOrgDashboard) || type?.includes("area")) {
      return {
        name: "View All Branches",
        id: "branch",
        onClick: async (id, name) => {
          await dispatch(
            getAllBranchInAreaAction({ areaId: id, permissionLevel })
          );
          historyPushWithParam("branches", name);
        },
      };
    }
    if ((position === "ZM" && !isOrgDashboard) || type?.includes("zone")) {
      return {
        name: "View All Areas",
        id: "area",
        onClick: async (id, name) => {
          await dispatch(
            getAllAreaInZoneAction({ zoneId: id, permissionLevel })
          );
          historyPushWithParam("areas", name);
        },
      };
    }
    if ((position === "SM" && !isOrgDashboard) || type?.includes("state")) {
      return {
        name: "View All Zones",
        id: "zone",
        onClick: async (id, name) => {
          await dispatch(
            getAllZonesInStateAction({ stateId: id, permissionLevel })
          );
          historyPushWithParam("zones", name);
        },
      };
    }
    if (position === "DR" && !isOrgDashboard) {
      return {
        name: "View All States",
        id: "state",
        onClick: async (id, name) => {
          await dispatch(
            getAllStateAction({ directorId: id, permissionLevel })
          );
          historyPushWithParam("states", name);
        },
      };
    }
  };

  useEffect(() => {
    const org_type = isOrgDashboard
      ? type
      : positionToOrgMapping2[user.position];

    const org_id = isOrgDashboard
      ? orgId
      : org_type === "cos"
      ? user.id
      : user[userOrgField]?.id;

    if (useUserDashboard) {
      dispatch(setUserDashboard({ userId: id || user.id, permissionLevel }));
      setViewListData(() => getUserDashboardViewList(user.position, type));
      return;
    }

    dispatch(setOrgDashboardAction({ orgId: org_id, type: org_type })).catch(
      (error) => {
        dispatch(showAlertAction(error));
      }
    );
    setViewListData(() => getUserDashboardViewList(user.position, type));
  }, [pathname]);

  const handleGetTableData = async (dateRange) => {
    setLoadingTableData(true);
    const org_type = isOrgDashboard
      ? type
      : positionToOrgMapping2[user.position];

    const org_id = isOrgDashboard
      ? orgId
      : org_type === "cos"
      ? user.id
      : user[userOrgField]?.id;

    // ORG TABLE
    dispatch(
      getOrgTableData({
        org_field_id: getOrgDashboardIdField(org_type),
        org_id: org_id || user.id,
        start_date:
          dateRange?.[0]?.format("YYYY/MM/DD") ||
          tableMeta.startDate.format("YYYY/MM/DD"),
        end_date:
          dateRange?.[1]?.format("YYYY/MM/DD") ||
          tableMeta.endDate.format("YYYY/MM/DD"),
      })
    ).then((result) => {
      setTableData(result);
      setLoadingTableData(false);
    });
  };

  const handleApproveRemittance = async (data, dateRage, total) => {
    if (!total || total === 0) {
      dispatch(
        showAlertAction({
          message:
            "You cannot remit ₦0, please try again when there is more money to remit.",
          level: "danger",
          isVisible: true,
        })
      );
      return;
    }

    if (data?.is_remitted) {
      return;
    }

    if (window.confirm("Are you sure you want to confirm remitance?.")) {
      setLoadingTableData(true);
      loadingTableData;
      const amount =
        Number(data?.realised_installment) +
        Number(data?.realised_savings) +
        Number(data?.prev_cash_in_hand_paid);

      const cashInHand =
        parseInt(data?.realizable_installment) +
        parseInt(data?.realizable_savings) -
        (parseInt(data?.realised_installment) +
          parseInt(data?.realised_savings));

      const org_type = isOrgDashboard
        ? type
        : positionToOrgMapping2[user.position];

      const org_id = isOrgDashboard
        ? orgId
        : org_type === "cos"
        ? user.id
        : user[userOrgField]?.id;

      dispatch(
        approveRemitance({
          date: data?.date,
          cash_in_hand: cashInHand,
          amount,
          org_field_id: getOrgDashboardIdField(org_type),
          org_id: org_id || user.id,
        })
      ).then(() => {
        handleGetTableData(dateRage);
      });
    }
  };

  const getTodayTotalCollection = () => {
    const dataInst = tableData?.find((inst) =>
      moment(inst.date).isSame(new Date(), "day")
    );

    if (dataInst) {
      return getTotal(dataInst);
    }
    return "-";
  };

  const onViewDailypay = (name) => historyPushWithParam("dailypay", name);

  useEffect(() => {
    handleGetTableData();
  }, [pathname]);

  return {
    isOrgDashboard,
    userOrgField,
    metadata: useUserDashboard ? userMetaData : orgMetaData,
    accumulations: useUserDashboard
      ? userDashboardData?.accumulations
      : orgDashboardData?.accumulations,
    orgType: type || userOrgField,
    viewListData,
    cardsData: cardData,
    useUserDashboard,
    onDateRangeChange: handleGetTableData,
    tableData,
    handleApproveRemittance,
    position: user.position,
    loadingTableData,
    user,
    todayCollection: getTodayTotalCollection(),
    onViewDailypay: onViewDailypay,
    loadingDashboard: loadingOrgDashboard || loadingDashboard,
    user,
    getUserDashboardViewList,
  };
};

export { useDashboard };
